























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GET_DEPARTMENT } from './getDepartment';
import DepartmentForm from '@/components/Department/DepartmentForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updateDepartment } from '../../queries/__generated__/updateDepartment';
import gql from 'graphql-tag';
import { departmentFragments } from '@/queries/Department';

const UPDATE_DEPARTMENT = gql`
  mutation updateDepartment(
    $id: ID!,
    $code: String!,
    $name: String!,
  ) {
    updateDepartment(
      input: {
        department: {
          id: $id,
          code: $code,
          name: $name,
        }
      }
    ) {
      department {
        ...departmentFragments
      }
    }
  },
  ${departmentFragments}
`;

@Component({
  components: {
    DepartmentForm,
  },
})
export default class DepartmentEdit extends Vue {
  @Prop([ Number, String ]) public id!: number | string;
  public GET_DEPARTMENT = GET_DEPARTMENT;
  public UPDATE_DEPARTMENT = UPDATE_DEPARTMENT;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatData(data: any) {
    data.unitId = data.unit.id;
    return data;
  }

  @Emit()
  public departmentUpdated(store: InMemoryCache, query: { data: GQL_updateDepartment }) {
    return query.data.updateDepartment && query.data.updateDepartment.department;
  }
}
